import React, { FC } from 'react';
import { useTranslate } from 'react-admin';
import { l } from '~/utils/solutions';
import { JsonInput } from './JsonInput';
import ProcessingFlowSelect from '~/components/ProcessingFlowSelect';

interface PartnerIncomingTransferFormProps {
  keyName: string;
}
export const PartnerIncomingTransferForm: FC<PartnerIncomingTransferFormProps> = ({ keyName }) => {
  const translate = useTranslate();
  const t = (key: string): string => translate(l(`featuresConfig.${key}`));
  return (
    <>
      <ProcessingFlowSelect sourceBase={`${keyName}.`} />
      <JsonInput
        label={t('processingParameters')}
        source={`${keyName}.processing.parameters`}
        validationError={t('jsonError')}
      />
    </>
  );
};
